module.exports = __webpack_public_path__ + "static/media/float_button_tw.259b90a7.png";